export default {
  getOptionsFilterAdditionalServices: state =>
    state.optionsFilterAdditionalServices,
  getListAdditionalServices: state => state.listAdditionalServices,
  getPaginationListAdditionalServices: state =>
    state.paginationListAdditionalServices,
  getModalConfirmNoAdditionalServices: state =>
    state.modalConfirmNoAdditionalServices,
  getModalConfirmMaxItens: state => state.modalConfirmMaxItens,

  getFilterName: state => state.filterName
}
